var map = {
	"./01.png": 98,
	"./02.png": 99,
	"./03.png": 100,
	"./04.png": 101,
	"./05.png": 102,
	"./06.png": 103,
	"./07.png": 104,
	"./08.png": 105,
	"./09.png": 106,
	"./10.png": 107,
	"./11.png": 108,
	"./12.png": 109,
	"./13.png": 110,
	"./14.png": 111,
	"./15.png": 112,
	"./16.png": 113,
	"./17.png": 114,
	"./18.png": 115,
	"./19.png": 116,
	"./20.png": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;